import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { InvestigationsRepository } from '../../../infrastructure/repositories/investigations.repository';
import { InvestigationsState } from '../../states/investigations.state';
import { InvestigationEmailTemplateSnapshotEntity } from '../../../domain/entities/investigation-email-template-snapshot.entity';

export interface GetInvestigationEmailTemplateSnapshotsQuery { investigationId: string; }
export interface GetInvestigationEmailTemplateSnapshotsResult { snapshots: InvestigationEmailTemplateSnapshotEntity[]; }

@Injectable({ providedIn: 'root' })
export class GetInvestigationEmailTemplateSnapshotsUseCase {
  private readonly _repository = inject(InvestigationsRepository);
  private readonly _state = inject(InvestigationsState);

  public execute(query: GetInvestigationEmailTemplateSnapshotsQuery): Observable<GetInvestigationEmailTemplateSnapshotsResult> {
    this._state.setLoadingEmailTemplateSnapshots(true);
    this._state.setErrorEmailTemplateSnapshots(null);
    return this._repository.getEmailTemplateSnapshots(query.investigationId).pipe(
      tap((snapshots) => {
        this._state.setEmailTemplateSnapshots(snapshots);
        this._state.setLoadingEmailTemplateSnapshots(false);
      }),
      map((snapshots) => ({ snapshots })),
      catchError((error) => {
        this._state.setErrorEmailTemplateSnapshots(error.message || 'Failed to load email templates');
        this._state.setLoadingEmailTemplateSnapshots(false);
        return throwError(() => error);
      }),
    );
  }
}
